module.exports = __webpack_public_path__ + "static/media/pie.d70eea47.svg";